<div id="chart" #chart *ngIf="isLoaded">
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [colors]="chartOptions.colors"
      [tooltip]="chartOptions.tooltip!"
    ></apx-chart>
  </div>
